import classnames from 'classnames'
import {ReactComponent as HeartLogo} from '../../../src/Hearticon.svg'
type Props = {
  settingName?: string
  flag: boolean
  handleFlag: Function
  description?: string
  descriptiontwo?: string
  uyiremeisettingName?: string
}

export const SettingsToggle = ({
  settingName,
  flag,
  handleFlag,
  description,
  descriptiontwo,
  uyiremeisettingName
}: Props) => {
  const toggleHolder = classnames(
    'w-14 h-8 flex shrink-0 items-center bg-gray-300 rounded-full p-1 duration-300 ease-in-out cursor-pointer',
    {
      'bg-green-400': flag,
    }
  )
  const toggleButton = classnames(
    'bg-white w-6 h-6 rounded-full shadow-md transform duration-300 ease-in-out cursor-pointer',
    {
      'translate-x-6': flag,
    }
  )

  return (
    <>
      <div className="flex justify-between gap-4 py-3">
        <div className="mt-1 text-left">
          <p className="dark:text-gray-300 leading-none">{settingName}</p>
          {uyiremeisettingName && (
            <p className="dark:text-gray-300 leading-none">
              {uyiremeisettingName} <HeartLogo className="heart-logo"/>
            </p>
          )}
          {description && (
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-300 settings-description">
              {description}
            </p>
          )}
          {descriptiontwo && (
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-300 settings-description-two">
              {descriptiontwo}
            </p>
          )}
          
        </div>
        <div className={toggleHolder} onClick={() => handleFlag(!flag)}>
          <div className={toggleButton} />
        </div>
      </div>
    </>
  )
}